import React, { useContext, useEffect } from 'react';
import './AncillaryPage.scss';
import NeedHelpPage from './NeedHelpPage';
import { SiteContext } from '../../../context/SiteContext';

export enum HeroType {
  Default = 1,
  Electric
}

type AncillaryPageProps = {
  title: string;
  heroType?: HeroType;
  children: React.ReactNode;
};

const AncillaryPage = ({
  title,
  heroType,
  children
}: AncillaryPageProps): JSX.Element => {
  const { site } = useContext(SiteContext);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const topDivClass =
    heroType === HeroType.Electric ? 'hero-image electric-image' : 'hero-image';

  return (
    <div className='ancillary-page'>
      <div className={topDivClass}>
        <h1 className='image-text'>{title}</h1>
      </div>
      <div className='flex-row ancillary-main'>
        <div className='flex-column left-column'>
          <NeedHelpPage
            showCallMeBackButton={!site.user.isDealer}
            showCallYouBackHeading={!site.user.isDealer}
          />
        </div>
        <div className='flex-column right-column'>{children}</div>
      </div>
    </div>
  );
};

export default AncillaryPage;
